import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Heading, Text, VStack } from '@chakra-ui/react';
import { useParams } from 'react-router-dom-v7';
import MFTabs from '../../components/MFTabs';
// Example tab components
const OverviewTab = () => (_jsxs(Box, { p: 6, children: [_jsx(Heading, { size: "md", mb: 4, children: "Overview" }), _jsx(Text, { children: "This is the overview tab content. It shows general information." })] }));
const DetailsTab = () => (_jsxs(Box, { p: 6, children: [_jsx(Heading, { size: "md", mb: 4, children: "Details" }), _jsx(Text, { children: "This is the details tab. It contains detailed information." })] }));
// Nested tab components for Settings
const SettingsGeneralTab = () => (_jsx(Box, { p: 4, children: _jsx(Text, { children: "General settings content goes here." }) }));
const SettingsAdvancedTab = () => (_jsx(Box, { p: 4, children: _jsx(Text, { children: "Advanced settings content goes here." }) }));
const SettingsTab = () => {
    const { id } = useParams();
    const settingsPath = `/tabs-example/${id}/settings`;
    return (_jsxs(Box, { p: 6, children: [_jsx(Heading, { size: "md", mb: 4, children: "Settings" }), _jsx(Text, { mb: 4, children: "This is the settings tab. Configure your preferences here." }), _jsx(MFTabs, { tabs: [
                    {
                        label: 'General',
                        component: SettingsGeneralTab,
                        slug: 'general',
                        searchParamValue: 'general'
                    },
                    {
                        label: 'Advanced',
                        component: SettingsAdvancedTab,
                        slug: 'advanced',
                        searchParamValue: 'advanced'
                    }
                ], enableRouting: true, routingMode: "searchParams", searchParamKey: "settings", searchParamScopePath: settingsPath, variant: "nav", defaultTab: "general", onTabChange: (slug, index) => {
                    // Tab change handler
                    // eslint-disable-next-line no-console
                    console.log(`Tab changed: ${slug} (index: ${index})`);
                } })] }));
};
const AnalyticsTab = () => (_jsxs(Box, { p: 6, children: [_jsx(Heading, { size: "md", mb: 4, children: "Analytics" }), _jsx(Text, { children: "This is the analytics tab. View your data and metrics here." })] }));
/**
 * Example view demonstrating MFTabs with path-based routing
 *
 * Routes setup in MFRouterRR7.tsx:
 * <Route path="/tabs-example/:id" element={<TabsExample />} />
 * <Route path="/tabs-example/:id/overview" element={<TabsExample />} />
 * <Route path="/tabs-example/:id/details" element={<TabsExample />} />
 * <Route path="/tabs-example/:id/settings" element={<TabsExample />} />
 * <Route path="/tabs-example/:id/analytics" element={<TabsExample />} />
 */
export default function TabsExample() {
    const { id } = useParams();
    const tabs = [
        {
            label: 'Overview',
            component: OverviewTab,
            slug: 'overview',
            path: 'overview' // Will be: /tabs-example/:id/overview
        },
        {
            label: 'Details',
            component: DetailsTab,
            slug: 'details',
            path: 'details' // Will be: /tabs-example/:id/details
        },
        {
            label: 'Settings',
            component: SettingsTab,
            slug: 'settings',
            path: 'settings' // Will be: /tabs-example/:id/settings
        },
        {
            label: 'Analytics',
            component: AnalyticsTab,
            slug: 'analytics',
            path: 'analytics' // Will be: /tabs-example/:id/analytics
        }
    ];
    return (_jsxs(VStack, { align: "stretch", spacing: 6, p: 6, children: [_jsxs(Box, { children: [_jsx(Heading, { size: "lg", mb: 2, children: "Tabs Example (Path-based Routing)" }), _jsxs(Text, { color: "gray.600", children: ["ID: ", id] }), _jsx(Text, { fontSize: "sm", color: "gray.500", mt: 2, children: "This example uses path-based routing. Each tab has its own route." })] }), _jsx(MFTabs, { tabs: tabs, enableRouting: true, routingMode: "path", basePath: `/tabs-example/${id}`, defaultTab: "overview", variant: "nav", onTabChange: (slug, index) => {
                    // Tab change handler
                    // eslint-disable-next-line no-console
                    console.log(`Tab changed: ${slug} (index: ${index})`);
                } })] }));
}
